import { render } from "./ConfirmRedeemModal.vue?vue&type=template&id=7f126588&scoped=true"
import script from "./ConfirmRedeemModal.vue?vue&type=script&lang=js"
export * from "./ConfirmRedeemModal.vue?vue&type=script&lang=js"

import "./ConfirmRedeemModal.vue?vue&type=style&index=0&id=7f126588&lang=scss&scoped=true"

import exportComponent from "D:\\a\\_work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f126588"]])

export default __exports__